import React, { useEffect, useRef, useState } from "react";
import optionsIcon from "assets/Icon_Btn_05.png";

type ChartOptions = {
  children: React.ReactNode;
};

type Props = ChartOptions;


const ChartOptions: React.FC<Props> = ({ 
  children 
}) => {
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleClickOutside = (event: any, ref: any) => {
    if (ref.current) {
      if (!ref.current.contains(event.target)) {
        setTimeout(() => {
          setOptionsMenuOpen(false);
        }, 300);
      }
    }
  };

  useEffect(() => {
    if (!optionsMenuOpen) {
      return;
    }
    const clickOutsideListenerFunction = (e: any) => handleClickOutside(e, wrapperRef);
    document.addEventListener("click", clickOutsideListenerFunction);

    return () => {
      document.removeEventListener("click", clickOutsideListenerFunction);
    };
  }, [optionsMenuOpen]);

  const handleUserMenuClick = () => {
    if (optionsMenuOpen) {
      setTimeout(() => {
        setOptionsMenuOpen(false);
      }, 300);
    } else {
      setOptionsMenuOpen(true);
    }
  };

  return (
    <div className="ChartOptions"  ref={ wrapperRef }>
      <button className="ChartOptionsButton" onClick={ handleUserMenuClick }><img src={ optionsIcon } alt="Options" /></button>
      <div className={ optionsMenuOpen ? "ChartMenu Visible" : "ChartMenu" }>
        { children }
      </div>
    </div>
  )  
};
  
export default ChartOptions;